export default __webpack_public_path__ + "static/media/undraw_warning_cyit.aff3fe00.svg";